import { BrowserModule } from "@angular/platform-browser";
import {
	NgModule,
	APP_INITIALIZER,
	ElementRef,
	CUSTOM_ELEMENTS_SCHEMA
} from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TruncatePipe } from "./pipes/truncate.pipe";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SearchComponent } from "./components/dmv/search/search.component";
import { SearchResultsComponent } from "./components/dmv/search-results/search-results.component";
import { ManualRenewComponent } from "./components/dmv/manual-renew/manual-renew.component";
import { CustomizeComponent } from "./components/order/customize/customize.component";
import { DonationComponent } from "./components/order/donation/donation.component";
import { PickupOptionsComponent } from "./components/order/pickup-options/pickup-options.component";
import { MailingDetailsComponent } from "./components/order/mailing-details/mailing-details.component";
import { PickupLocationComponent } from "./components/order/pickup-location/pickup-location.component";
import { ReviewComponent } from "./components/order/review/review.component";
import { ReviewCartComponent } from "./components/order/review-cart/review-cart.component";
import { PaymentDetailsComponent } from "./components/payment/payment-details/payment-details.component";
import { BaseComponent } from "./components/base/base.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { LoaderOverlayComponent } from "./components/loader-overlay/loader-overlay.component";
import { HomeComponent } from "./components/home/home.component";
import { DMVDataService } from "./services/dmv/dmv-data.service";
import { AppConfigService } from "./services/config/app-config.service";
import { RestServiceConstants } from "./constants/rest-service.constants";
import { ResourceUtil } from "./utils/resource.util";
import { MEGDataService } from "./services/meg/meg-data.service";
import { CountyLandingComponent } from "./components/dmv/county-landing/county-landing.component";
import { CustomizeOrderComponent } from "./components/dmv/customize-order/customize-order.component";
import { ShopingCartComponent } from "./components/dmv/shoping-cart/shoping-cart.component";
import { OverlayPlateComponent } from "./components/dmv/overlay-plate/overlay-plate.component";
import { ConfirmModelComponent } from "./components/dmv/confirm-model/confirm-model.component";
import { AddUpdateInsuranceComponent } from "./components/dmv/add-update-insurance/add-update-insurance.component";
import { DmvDonationComponent } from "./components/dmv/donation/donation.component";
import { DmvPickupMethodComponent } from "./components/dmv/pickup-method/pickup-method.component";
import { DmvPickupMailingComponent } from "./components/dmv/pickup-mailing/pickup-mailing.component";
import { DmvPickupInPersonComponent } from "./components/dmv/pickup-in-person/pickup-in-person.component";
import { PickupInPersonModelComponent } from "./components/dmv/pickup-in-person-model/pickup-in-person-model.component";
import { DmvReviewCartComponent } from "./components/dmv/review-cart/review-cart.component";
import { DmvReviewCartWithBillingComponent } from "./components/dmv/dmv-review-cart/dmv-review-cart.component";
import { AddressChangeModelComponent } from "./components/dmv/address-change-model/address-change-model.component";
import { RouteConfirmationComponent } from "./components/route-confirmation/route-confirmation.component";
import { PrivacyComponent } from "./components/privacy/privacy.component";
import { MinusSignToParens } from "./pipes/minusSignToParens";
import { AsterikToHtmlTags } from "./pipes/asterikToHtmlTags";
import { AboutComponent } from "./components/about/about.component";
import { TermsComponent } from "./components/terms/terms.component";
import { ServiceFeeComponent } from "./components/dmv/service-fee-model/service-fee-model.component";
import { SafePipe } from "./pipes/safe";
import { DeviceDetectorModule } from "ngx-device-detector";
import { TextMaskModule } from "angular2-text-mask";
import {
	AgmCoreModule,
	AgmMap,
	GoogleMapsAPIWrapper,
	LAZY_MAPS_API_CONFIG
} from "@agm/core";
import { GoogleMapsConfig } from "./services/global/google-map-config";
import { SvgComponent } from "./components/svg/svg.component";
import { SvgDefinitionsComponent } from "./components/svg-definitions/svg-definitions.component";
import { PNPPaymentDetailsComponent } from "./components/pnp-payment/payment-details/payment-details.component";
import { LogInComponent } from "./components/user/log-in/log-in.component";
import { CreateAccountComponent } from "./components/user/create-account/create-account.component";
import { AccountFaqComponent } from "./components/user/account-faq/account-faq.component";
import { ProfileComponent } from "./components/user/profile/profile.component";
import { AccountCreatedComponent } from "./components/user/account-created/account-created.component";
import { ChangePasswordComponent } from "./components/user/change-password/change-password.component";
import { ResetPasswordComponent } from "./components/user/reset-password/reset-password.component";
import { ChangeEmailAddressComponent } from "./components/user/change-email-address/change-email-address.component";
import { EditContactInfoComponent } from "./components/user/edit-contact-info/edit-contact-info.component";
import { EditPaymentMethodComponent } from "./components/user/edit-payment-method/edit-payment-method.component";
import { SelectPaymentMethodComponent } from "./components/user/select-payment-method/select-payment-method.component";
import { BillingAccountComponent } from "./components/user/billing-account/billing-account.component";
import { ContactInfoComponent } from "./components/user/contact-info/contact-info.component";
import { PaymentMethodsComponent } from "./components/user/payment-methods/payment-methods.component";
import { NotificationsComponent } from "./components/user/notifications/notifications.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { EmailAddressChangedComponent } from "./components/user/email-address-changed/email-address-changed.component";
import { PasswordChangedComponent } from "./components/user/password-changed/password-changed.component";
import { ResetPasswordSucessComponent } from "./components/user/reset-password-sucess/reset-password-sucess.component";
import { USERDataService } from "./services/user/user-data.service";
import { USERStoreService } from "./services/user/user-store.service";
import { ConfirmDeleteModelComponent } from "./components/user/confirm-delete-model/confirm-delete-model.component";
import { DatePipe } from "@angular/common";
import { LoginPopupModelComponent } from "./components/dmv/login-popup/login-popup-model.component";
import { RenewalRemindersModelComponent } from "./components/dmv/renewal-reminders/renewal-reminders-model.component";
import { GsgPaymentDetailsComponent } from "./components/gsg-payment/payment-details/payment-details.component";
import { PlateChangeComponent } from "./components/dmv/plate-change/plate-change.component";
import { MegPaymentDetailComponent } from "./components/meg-payment/payment-detail/payment-detail.component";
import { DuplicateComponent } from "./components/dmv/dublicate/duplicate.component";
import { EnrollmentCancellationComponent } from "./components/user/enrollment-cancellation/enrollment-cancellation.component";
import { EnrollmentComponent } from "./components/user/enrollment/enrollment.component";
import { AnnouncementComponent } from "./components/announcement/announcement.component";
@NgModule({
	declarations: [
		LoginPopupModelComponent,
		RenewalRemindersModelComponent,
		GsgPaymentDetailsComponent,
		TermsComponent,
		PrivacyComponent,
		AboutComponent,
		AppComponent,
		TruncatePipe,
		SearchComponent,
		SearchResultsComponent,
		ShopingCartComponent,
		OverlayPlateComponent,
		ServiceFeeComponent,
		AddUpdateInsuranceComponent,
		PickupInPersonModelComponent,
		DmvReviewCartWithBillingComponent,
		ConfirmModelComponent,
		ConfirmDeleteModelComponent,
		RouteConfirmationComponent,
		AddressChangeModelComponent,
		CustomizeOrderComponent,
		ManualRenewComponent,
		DmvDonationComponent,
		DmvReviewCartComponent,
		DmvPickupMethodComponent,
		DmvPickupInPersonComponent,
		DmvPickupMailingComponent,
		CustomizeComponent,
		DonationComponent,
		PickupOptionsComponent,
		MailingDetailsComponent,
		PickupLocationComponent,
		LoaderOverlayComponent,
		ReviewComponent,
		ReviewCartComponent,
		PaymentDetailsComponent,
		BaseComponent,
		FooterComponent,
		HeaderComponent,
		HomeComponent,
		CountyLandingComponent,
		SvgComponent,
		SvgDefinitionsComponent,
		MinusSignToParens,
		AsterikToHtmlTags,
		SafePipe,
		PNPPaymentDetailsComponent,
		LogInComponent,
		CreateAccountComponent,
		AccountFaqComponent,
		ProfileComponent,
		AccountCreatedComponent,
		ChangePasswordComponent,
		ResetPasswordComponent,
		ChangeEmailAddressComponent,
		EditContactInfoComponent,
		EditPaymentMethodComponent,
		SelectPaymentMethodComponent,
		BillingAccountComponent,
		ContactInfoComponent,
		PaymentMethodsComponent,
		NotificationsComponent,
		EmailAddressChangedComponent,
		PasswordChangedComponent,
		ResetPasswordSucessComponent,
		PlateChangeComponent,
		MegPaymentDetailComponent,
		DuplicateComponent,
		EnrollmentCancellationComponent,
		EnrollmentComponent,
		AnnouncementComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		TextMaskModule,
		FormsModule,
		BrowserAnimationsModule,
		ReactiveFormsModule,
		AgmCoreModule.forRoot(),
		DeviceDetectorModule.forRoot()
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	providers: [
		DMVDataService,
		MEGDataService,
		USERDataService,
		USERStoreService,
		DatePipe,
		GoogleMapsAPIWrapper,
		{
			provide: APP_INITIALIZER,
			useFactory: configServiceLoad,
			deps: [AppConfigService],
			multi: true
		},
		{ provide: LAZY_MAPS_API_CONFIG, useClass: GoogleMapsConfig }
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
export function configServiceLoad(appConfigService: AppConfigService) {
	const configServiceLoadFactory = () =>
		appConfigService.load(
			ResourceUtil.getPropertyResourceUrl(),
			RestServiceConstants.APP_CONFIG_FILE_URI
		);
	return configServiceLoadFactory;
}
